module.exports = __webpack_public_path__ + "static/media/check.5f0b29f2.svg";